import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Typography,
  Paper,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Grid,
  IconButton,
} from "@material-ui/core";
import withWidth, { isWidthUp } from '@material-ui/core/withWidth';
import { InsertDriveFile } from "@material-ui/icons";
import AppointmentHistory from "./AppointmentHistory";
import { history } from "../../components/helpers/History";
import { AccountCircle } from "@material-ui/icons";
import { useSelector } from "react-redux";
import { USER_ROLE } from "../../components/security/UserRole";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    margin: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    color: theme.palette.text.secondary,
  },
  list: {
    display: "flex",
    flexDirection: "column",
  },
  docButton: {
    marginRight: theme.spacing(2),
    background: "#8b5dc8",
    textTransform: "none",
    color: "#FFF",
    borderRadius: 10,
    border: 0,
    boxShadow: "0 0px 0px 0px rgba(0, 0, 0, 0)",
  },
  doctorButton: {
    marginRight: theme.spacing(2),
    background: "#138bb9",
    textTransform: "none",
    color: "#FFF",
    borderRadius: 10,
    border: 0,
    boxShadow: "0 0px 0px 0px rgba(0, 0, 0, 0)",
  },
  profileButton: {
    marginRight: theme.spacing(2),
    background: "#95c85d",
    textTransform: "none",
    color: "#FFF",
    borderRadius: 10,
    border: 0,
    boxShadow: "0 0px 0px 0px rgba(0, 0, 0, 0)",
  },
  typography: {
    padding: theme.spacing(4),
  },
}));

export default function CenteredGrid(props) {
  const classes = useStyles();
  const user = useSelector((state) => state.authentication.user);
  const userRole = user.userRole ? user.userRole : '';
  console.log(props.width);
  return (
    <div className={classes.root}>
      <AppointmentHistory
        showAddNewAppointment={ userRole === USER_ROLE.PATIENT ?true:false}
        isCalenderView={false}
        patientId= { userRole === USER_ROLE.PATIENT ?user.patientId:''}
        doctorId = {userRole === USER_ROLE.DOCTOR ?user.doctorId:''}
        showSingleGrid={isWidthUp('sm', props.width)?true:false}
        isViewWeeklyAppointment ={true}
        showEditAppointment = {true}
        headerTitle={'Weekly Appointments'}
      />
    </div>
  );
}
